import * as T from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { Box, Flex, Link, Modal, Table, Text } from '@olist/united';

import { ARTICLE_DATA_BANK } from '../../../utils/external-urls';

const LinkMoreBankInfo = styled(Link)`
  text-align: right;
`;

const BankDoubts = ({ banks, openModal, setOpenModal }) => {
  const { t } = useTranslation();

  if (!banks) {
    return null;
  }

  const banksWithValidationRules = banks.filter((bank) => {
    const hasAgencyRegex = bank.agencyRegex !== '';
    const hasAccountRegex = bank.accountRegex !== '';
    return hasAgencyRegex && hasAccountRegex ? 1 : 0;
  });

  if (banksWithValidationRules.length === 0) {
    return null;
  }

  const TextProps = {
    color: `foundation.shadeDark`,
    fontSize: 1,
    display: 'inline-block',
  };

  const TextPropsDarker = {
    ...TextProps,
    color: `foundation.shadeDarker`,
    fontWeight: 600,
  };

  const banksTableDesktop = (
    <Box display={['none', 'none', 'flex']}>
      <Table size="small">
        <Table.Head>
          <Table.Row>
            <Table.Cell pl={0} width="50%" header>{t`bank`}</Table.Cell>
            <Table.Th width="20%">{t`agency`}</Table.Th>
            <Table.Th width="30%">{t`account`}</Table.Th>
          </Table.Row>
        </Table.Head>
        <Table.Body mb={1} data-testid="bankList">
          {banksWithValidationRules.map((bank) => (
            <Table.Row key={bank.label}>
              <Table.Cell width="50%" pl={0}>
                <Text {...TextPropsDarker}>{bank.label}</Text>
              </Table.Cell>
              <Table.Td width="20%">
                <Text {...TextPropsDarker}>{bank.agencyPlaceholder}</Text>
              </Table.Td>
              <Table.Td width="30%" pr={0}>
                <Text {...TextPropsDarker}>{bank.accountPlaceholder}</Text>
              </Table.Td>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Box>
  );

  const banksTableMobile = banksWithValidationRules.map((bank) => (
    <Box mb={4} flexDirection="column" key={bank.label} display={['flex', 'flex', 'none']}>
      <Table>
        <Table.Head>
          <Table.Row key={bank.code}>
            <Table.Cell px={0}>
              <Text fontSize={2}>
                <b>{bank.label}</b>
              </Text>
            </Table.Cell>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          <Table.Row small>
            <Table.Cell py={1} px={0}>
              <Flex justifyContent="space-between">
                <Text {...TextProps}>{t`agency`}</Text>
                <Text {...TextPropsDarker}>{bank.agencyPlaceholder}</Text>
              </Flex>
            </Table.Cell>
          </Table.Row>
          <Table.Row small>
            <Table.Cell py={1} px={0}>
              <Flex justifyContent="space-between">
                <Text {...TextProps}>{t`account`}</Text>
                <Text {...TextPropsDarker}>{bank.accountPlaceholder}</Text>
              </Flex>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </Box>
  ));

  return (
    <Flex>
      <Modal
        ariaHideApp={false}
        onRequestClose={() => setOpenModal(false)}
        isOpen={openModal}
        variation="theater"
        maxWidth="650px"
        px={['5%', '5%', '45px']}
        pl={['5%', '5%', '45px']}
      >
        <Flex justifyContent="space-between" mb={4}>
          <Text.H1 style={{ fontSize: `24px` }} fontWeight="semibold" pr={3}>{t`help`}</Text.H1>
          <LinkMoreBankInfo
            role="link"
            href={ARTICLE_DATA_BANK}
            variation="link"
            target="_blank"
            px={0}
            color="foundation.primaryDefault"
          >
            {t`still in doubt?`}
          </LinkMoreBankInfo>
        </Flex>
        {banksTableDesktop}
        {banksTableMobile}
      </Modal>
    </Flex>
  );
};

BankDoubts.propTypes = {
  banks: T.arrayOf(
    T.shape({
      label: T.string,
      agencyPlaceholder: T.string,
      accountPlaceholder: T.string,
    })
  ),
  openModal: T.bool.isRequired,
  setOpenModal: T.func.isRequired,
};

BankDoubts.defaultProps = {
  banks: [],
};

export default BankDoubts;
